export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            关于51黑料吃瓜网
          </h2>
          <p className="mt-2 text-sm text-foreground-500">全网最全吃瓜内容聚合平台</p>
        </div>
        <div className="mt-8 flex flex-col lg:flex-row items-center gap-6 lg:gap-10">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className="ri-fire-fill text-3xl md:text-4xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              51黑料吃瓜网是专注娱乐八卦与网络热点的一站式资讯聚合平台，致力于为广大"吃瓜群众"提供最新、最全、最热的黑料吃瓜内容。平台每日从全网精选明星动态、网红八卦、影视综艺、社会热点等优质内容，通过51吃瓜官网全网最新入口实时更新，确保用户第一时间获取黑料吃瓜最新地址。我们坚持内容真实、更新及时、访问便捷三大原则，让每一位用户都能在51黑料吃瓜网站找到自己关心的热点话题，畅享吃瓜乐趣。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}